import { render, staticRenderFns } from "./FreeBenefits.vue?vue&type=template&id=0a172726&scoped=true&"
import script from "./FreeBenefits.vue?vue&type=script&lang=js&"
export * from "./FreeBenefits.vue?vue&type=script&lang=js&"
import style0 from "./FreeBenefits.vue?vue&type=style&index=0&id=0a172726&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a172726",
  null
  
)

export default component.exports